import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [1, 3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "center",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "Real driving noise results as a superposition of multiple sound sources which behave differently at distinct operating points (e.g. vehicle speeds). The sound emmited by these sources travels through different  (e.g. air-borne or structure-borne) paths, which alter the characteristics of the sound, before reaching the left and right ears of the driver or passengers.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/2-power.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
